module.exports = __webpack_public_path__ + "img/untitled.e1da488a.svg";